import styled from 'styled-components'
import Modal from 'components/Modal'

export const ModalBody = styled(Modal.Body)`
  word-break: break-word;
`

export const SectionTitle = styled.h1`
  margin: 0;

  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5;

  color: ${({ theme }) => theme.colors.text.dark.base};
`
